<template>
    <div class="card-wrapper">
        <div v-if="video" :class="['card', cardType]" @click="videoSelected()">
            <div class="img-wrapper">
                <img class="card-img-top" :src="video.logoMoyen ? video.logoMoyen : video.logo" @error="video.logo=video.logoerror" :alt="video.title">
                <div class="overlay-text" v-if="cardType !=='demo'">
                    <span class="date-text" v-if="horizontal">{{dateText}}</span>
                    <div class="tag-info card-date" v-if="video.date && cardElements.date">
                        <span v-if="horizontal">{{dateFormat(video.date)}}</span>
                        <span v-if="!horizontal">{{video.date | dateFilter}}</span>
                    </div>
                    <div class="tag-info card-duration" v-if="video.duration && cardElements.duration">{{video.duration}}</div>
                    <div class="tag-info card-nbviews" v-if="(video.nbviews && cardElements.nbviews) || ((stats.length || relatedStats.length) && getStat(video)!==0 )"> {{getStat(video)}}</div>
                </div>

                <div class="overlay-text-demo" v-if="cardType ==='demo'">
                    <div class="tag-info card-duration" v-if="video.duration ">{{video.duration}}</div>
                </div>

            </div>
            <div :class="cardType === 'small'  ? 'card-img-overlay' : 'card-body'">
                <h5 class="card-title" v-if="cardElements.title" :title="video.title">{{video.title}}</h5>
                <p class="card-text" v-if="hasDescription" v-html="video.description"></p>

                <div  class="Carddemo" v-if="cardType==='demo'">
                    <div class="tag-info card-date" v-if="video.date"  >
                        <span class="icon icon-demo-calendar"></span>
                        <span class="date-text" v-if="horizontal">{{dateText}}</span>
                        <span v-if="horizontal">{{dateFormat(video.date)}}</span>
                        <span v-if="!horizontal">{{video.date | dateFilter}}</span>
                    </div>
                    <div class="tag-info card-nbviews"  v-if="video.nbviews || ((stats.length || relatedStats.length) && getStat(video)!==0 ) " >
                        <span class="icon icon-demo-view"></span>
                        {{getStat(video)}}
                    </div>
                </div>
                <div v-else class="info-card">
                    <div class="tag-theme " v-if="hasTag && video.theme && video.theme.title">
                        {{video.theme && video.theme.title}}
                    </div>
                    <div class="tag-info card-date" v-if="video.date && cardElements.date">
                        <span class="icon date"></span>
                        <span class="date-text" v-if="horizontal">{{dateText}}</span>
                        <span v-if="horizontal">{{dateFormat(video.date)}}</span>
                        <span v-if="!horizontal">{{video.date | dateFilter}}</span>
                    </div>
                    <div class="tag-info card-duration" v-if="video.duration && cardElements.duration">
                        <span class="icon duration"></span>
                        {{video.duration}}
                    </div>
                    <div class="tag-info card-nbviews" v-if="(video.nbviews && cardElements.nbViews) || ((stats.length || relatedStats.length) && getStat(video)!==0 )">
                        <span class="icon nb-views"></span>
                        {{getStat(video)}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'video-vignette-html',
    data() {
      return {
        cardElements: {
          title: true,
          description: true,
          date: true,
          duration: true,
          nbViews: true,
        },

      };
    },
    props: {
      video: {
        type: Object
      },
      stats:{
        type: Array,
        default: () => [], // Shorthand return function
      },
      relatedStats:{
        type: Array,
        default: () => [], // Shorthand return function
      },
      cardType: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'small', 'wide', 'overlay'].indexOf(value) !== -1
        }
      },
      hide: {
        type: Array,
        default: () => [], // Shorthand return function
      },
      horizontal:{
        type: Boolean,
        default : false
      },
      dateText:{
        type:String,
        default: ''
      },
      hasTag:{
        type: Boolean,
        default : false
      }
    },
    methods:{
      videoSelected() {
        this.$emit('selected', this.video);
      },
      getStat(video){
        if(this.stats && this.stats.length > 0){
          return this.stats.find(v=>v.id===video.id).number_visits;
        }else if(this.relatedStats && this.relatedStats.length > 0) {
          return this.relatedStats.find(v=>v.id===video.id).number_visits;
        }else{
          return video.nbviews
        }
      },
      dateFormat(date){
        const d = new Date(date);
        const ye = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(d);
        const mo = new Intl.DateTimeFormat('fr', { month: 'long' }).format(d);
        const da = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(d);
        return `${da} ${mo} ${ye}`
      },
    },
    computed: {
      convertViews() {
        var digits = 1;
        var si = [
          {value: 1, symbol: ""},
          {value: 1E3, symbol: " k"},
          {value: 1E6, symbol: " M"},
          {value: 1E9, symbol: " G"},
          {value: 1E12, symbol: " T"},
          {value: 1E15, symbol: " P"},
          {value: 1E18, symbol: " E"}
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var i;
        for (i = si.length - 1; i > 0; i--) {
          if (parseInt(this.video.vueNbr) >= si[i].value) {
            break;
          }
        }
        return (parseInt(this.video.vueNbr) / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      },
      hasDescription(){
        return this.horizontal && this.dateText ? this.cardElements.description && this.video.description : this.cardElements.description
      }
    },
    filters:{
      dateFilter: function (value) {
        if(value){
          var dateToChange = new Date(value);
          var d = dateToChange.getDate() < 10 ? "0"+dateToChange.getDate():dateToChange.getDate();
          var mm = dateToChange.getMonth() +1;
          var m = mm < 10 ? "0"+mm: mm;
          var y = dateToChange.getFullYear();
          return `${d}/${m}/${y}`;
        }
      }
    },
    created() {
      this.hide.forEach(e => {
        this.cardElements[e] = false;
      });
    }
  }
</script>

<style scoped lang="scss">

    // Card
    $card-margin-bottom: var(--video-vignette-margin-bottom, 30px);
    $card-bg: var(--video-vignette-bg, #fff);
    $card-border: var(--video-vignette-border, none);
    $card-border-radius: var(--video-vignette-border-radius, .15rem);

    // Card body
    $card-spacer-x: var(--video-vignette-spacer-x, .8rem);
    $card-spacer-y: var(--video-vignette-spacer-y, .5rem);
    $card-inner-border-radius: var(--video-vignette-border-radius, $card-border-radius);

    // Card Image
    $card-img-overlay-padding: var(--video-vignette-overlay-padding, 1em);

    // Card title
    $card-title-color: var(--video-vignette-title-color, inherit);
    $card-title-max-lines: var(--video-vignette-title-max-lines, 1);
    $card-title-font-size: var(--video-vignette-title-font-size, 1.2em);

    // Card text
    $card-text-max-lines: var(--video-vignette-text-max-lines, 2);

    $meta-text-font-size: var(--video-vignette-meta-text-font-size, .8em);
    $card-duration-date-bg: var(--video-vignette-duration-date-bg,rgba(17, 80, 160, .7));
    $card-duration-overlay-bottom: var(--video-vignette-duration-overlay-bottom,0);
    $card-date-overlay-bottom: var(--video-vignette-date-overlay-bottom,0);

    @mixin lineClamp($nb-lines) {
        display: -webkit-box;
        -webkit-line-clamp: $nb-lines;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -o-text-overflow: ellipsis;
        line-height: 1.2em;
        height: calc(#{$nb-lines} * 1.2em);
    }

    .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        cursor: pointer;
        background-color: $card-bg;
        background-clip: border-box;
        border: $card-border;
        border-radius: $card-border-radius;
        margin-bottom: $card-margin-bottom;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transform: translateY(0);
        &:hover {
            box-shadow: 0 7px 14px rgba(0, 0, 0, 0.15), 0 5px 5px rgba(0, 0, 0, 0.22);
            transform: translateY(-1px);
            .card-img-top {
                transform: scale(1.1);
            }
        }
        &.overlay, &.wide{
            .overlay-text {
                display: block;
            }
            .tag-info {
                display: none;
            }
        }

        .overlay-text {
            color: #ffffff;
            display: none;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            .tag-info {

                display: inline-block;
                padding: .25em .4em;
                font-size: 75%;
                font-weight: 700;
                line-height: 1;
                text-align: center;
                white-space: nowrap;
                vertical-align: baseline;
                border-radius: .25rem;
                background-color: $card-duration-date-bg;
                margin: .4em; &.wide{
                .card-date{
                    display: none;
                }

            }
                position: absolute;
                &.card-date {
                    bottom:  $card-date-overlay-bottom;
                    left: 0;
                }
                &.card-duration {
                    bottom:$card-duration-overlay-bottom;
                    right: 0;
                }
            }

        }
    }
    .wide{
        flex-direction: row;
        width: 100%;
        height: 100%;
    }
    .img-wrapper {
        border-top-left-radius: $card-inner-border-radius;
        border-top-right-radius: $card-inner-border-radius;
        position: relative;
        overflow: hidden;
    }

    .card-body {
        // Enable `flex-grow: 1` for decks and groups so that card blocks take up
        // as much space as possible, ensuring footers are aligned to the bottom.
        flex: 1 1 auto;
        padding: $card-spacer-x;
        width: 100%;
    }

    .card-title {
        color: $card-title-color;
        margin-bottom: $card-spacer-y;
        font-size: $card-title-font-size;
        @include lineClamp($card-title-max-lines);
    }

    .card-subtitle {
        margin-top: -$card-spacer-y / 2;
        margin-bottom: 0;
    }

    .card-text {
        margin-bottom: .5rem;
        font-size: .8em;
        color: #555555;
        @include lineClamp($card-text-max-lines);
        &:last-child {
            margin-bottom: 0;
        }
    }

    .card-link {
        &:hover {
            text-decoration: none;
        }

        + .card-link {
            margin-left: $card-spacer-x;
        }
    }

    // Card image
    .card-img-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: $card-img-overlay-padding;
        background-color: rgba(0, 0, 0, .4);
        color: #ffffff;
        border-radius: $card-inner-border-radius;
        .card-title {
            position: absolute;
            bottom: 0;
            margin-bottom: $card-img-overlay-padding;
            margin-right: $card-img-overlay-padding;
            font-weight: 700;
            font-size: $card-title-font-size;
            height: initial;
        }
        .tag-info {
            display: inline-block;
            padding: .4em .8em;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .25rem;
            background-color:$card-duration-date-bg;
            margin: $card-img-overlay-padding;
            position: absolute;
            .icon{
                display: none;
            }
            &.card-date {
                top: 0;
                left: 0;
            }
            &.card-duration {
                top: 0;
                right: 0;
            }
        }
    }

    .card-img {
        width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch
        border-radius: $card-inner-border-radius;
    }

    // Card image caps
    .card-img-top {
        width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch
        border-top-left-radius: $card-inner-border-radius;
        border-top-right-radius: $card-inner-border-radius;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    }

    .card-img-bottom {
        width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch
        border-bottom-left-radius: $card-inner-border-radius;
        border-bottom-right-radius: $card-inner-border-radius;
    }

    .tag-info {
        font-size: $meta-text-font-size;
        display: flex;
        align-items: center;
        .icon{
            display: inline-block;
            width: 1em;
            height: 1em;
            background-size: 100%;
            margin-right: .4em;
            &.date {
                background-image: url(data:image/svg+xml;base64,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);
            }
            &.duration {
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAzFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABw77eQAAAAQ3RSTlMAAgYHDA0SFBscLS4vMTJERUdITE1UY2ZoamtvcHF3e3x9gJiZmpydnp+goaK3ubq7zc7Q09TV1t7f4O7v8PH19vf78tujoQAAAQBJREFUeAFd0OtW4jAUR/F/mTIzCsoFrBcroFBQQFQqKFIqst//nWwTwODv405W1smR5dWjOCGJezVPjuYbO/Pmvv65xzUobPMTmdWwHbSHKzITe/AArENfOf96DfTN28B7SZm/laJUWgANyXuFrxPlbrmQdPwJc091IJRxx5UyIVBVBCv/oPspdBXDUAddY5gqhfav3oFEGwgk/W+1Ws/bHsBGib1/Ru5yOxdLxTCS9O88d/Tzfg9SX66imacG3Mhh57f/PXVyyf7X7GdR3ufyh92PNHD2WQzXQKRcYUImHXWCzjgl81iQPejjikw2GjN2Zg05vGp3umT50q14Mr4BlHk7WVOscf8AAAAASUVORK5CYII=);
            }
            &.nb-views {
                background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OC44NSA0ODguODUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ4OC44NSA0ODguODU7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPGc+Cgk8cGF0aCBkPSJNMjQ0LjQyNSw5OC43MjVjLTkzLjQsMC0xNzguMSw1MS4xLTI0MC42LDEzNC4xYy01LjEsNi44LTUuMSwxNi4zLDAsMjMuMWM2Mi41LDgzLjEsMTQ3LjIsMTM0LjIsMjQwLjYsMTM0LjIgICBzMTc4LjEtNTEuMSwyNDAuNi0xMzQuMWM1LjEtNi44LDUuMS0xNi4zLDAtMjMuMUM0MjIuNTI1LDE0OS44MjUsMzM3LjgyNSw5OC43MjUsMjQ0LjQyNSw5OC43MjV6IE0yNTEuMTI1LDM0Ny4wMjUgICBjLTYyLDMuOS0xMTMuMi00Ny4yLTEwOS4zLTEwOS4zYzMuMi01MS4yLDQ0LjctOTIuNyw5NS45LTk1LjljNjItMy45LDExMy4yLDQ3LjIsMTA5LjMsMTA5LjMgICBDMzQzLjcyNSwzMDIuMjI1LDMwMi4yMjUsMzQzLjcyNSwyNTEuMTI1LDM0Ny4wMjV6IE0yNDguMDI1LDI5OS42MjVjLTMzLjQsMi4xLTYxLTI1LjQtNTguOC01OC44YzEuNy0yNy42LDI0LjEtNDkuOSw1MS43LTUxLjcgICBjMzMuNC0yLjEsNjEsMjUuNCw1OC44LDU4LjhDMjk3LjkyNSwyNzUuNjI1LDI3NS41MjUsMjk3LjkyNSwyNDguMDI1LDI5OS42MjV6IiBmaWxsPSIjNGQ0ZDRkIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
            }
        }
    }



    /*demo*/
    .Carddemo{
        display: flex;
        justify-content: space-between;
    }
    .overlay-text-demo{
        display: none;
    }
    .card{
        &.demo{
            .overlay-text-demo{
                display: block!important;
                color: #ffffff;
                display: none;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;

                .tag-info {

                    display: inline-block;
                    padding: .25em .4em;
                    font-size: 75%;
                    font-weight: 700;
                    line-height: 1;
                    text-align: center;
                    white-space: nowrap;
                    vertical-align: baseline;
                    border-radius: .25rem;
                    background-color: #262626;
                    margin: .4em; &.wide{
                    .card-date{
                        display: none;
                    }

                }
                    position: absolute;
                    &.card-date {
                        bottom:  $card-date-overlay-bottom;
                        left: 0;
                    }
                    &.card-duration {
                        bottom:$card-duration-overlay-bottom;
                        right: 0;
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/video-vignette/src/components/Component.vue